import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Sidebar, Topbar } from "./components"
import { Grid, Layout, Spin, message } from "antd"
import { useIsFetching, useIsMutating, useQuery } from "react-query"
import * as COMMONS from "common/common"
import * as API from "common/api"

const { useBreakpoint } = Grid
const { Header, Sider, Content } = Layout

const AdminMain = (props) => {
  const { children } = props
  const navigate = useNavigate()

  const isMountedRef = COMMONS.USE_IS_MOUNTED_REF()

  const [isCollapsed, setIsCollapsed] = useState(true)

  const [auth, setAuth] = useState({})
  const [systemSettings, setSystemSettings] = useState(undefined)

  const breakpoint = useBreakpoint()
  const isHamburger = !breakpoint.xl

  const isFetching =
    useIsFetching({
      fetchStatus: "fetching",
    }) > 0

  const isMutating = useIsMutating() > 0

  const collapse = () => {
    setIsCollapsed(true)
  }

  const expand = () => {
    setIsCollapsed(false)
  }

  const collapseToggle = () => {
    if (isCollapsed) {
      expand()
    } else {
      collapse()
    }
  }

  useQuery(API.QUERY_KEY_ADMIN_AUTH, API.ADMIN_GET_AUTH, {
    onSuccess: (response) => {
      if (isMountedRef.current) {
        if (response?.data) {
          setAuth(response.data)
        } else {
          setAuth({})
        }
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  useQuery([API.QUERY_KEY_ADMIN_SETTINGS], API.ADMIN_GET_SETTINGS, {
    onSuccess: (response) => {
      if (isMountedRef.current) {
        setSystemSettings(response?.data || undefined)
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  const childrenWithProps = React.Children.map(children, (element) =>
    React.cloneElement(element, {
      auth: auth,
      systemSettings: systemSettings,
    })
  )

  useEffect(() => {
    if (isHamburger) {
      collapse()
    } else {
      expand()
    }
  }, [isHamburger])

  return (
    <>
      <div className="flex flex-col w-full min-h-full">
        <Spin
          spinning={isFetching || isMutating}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1001,
          }}
        >
          <Layout className="min-h-full">
            {isHamburger ? (
              isCollapsed ? (
                <div></div>
              ) : (
                <div
                  onClick={collapse}
                  className="absolute top-0 left-0 bg-black bg-opacity-50 w-full h-full z-20"
                ></div>
              )
            ) : isCollapsed ? (
              <div
                style={{
                  flex: "0 0 80px",
                  minWidth: "80px",
                  maxWidth: "80px",
                  overflow: "hidden",
                }}
              ></div>
            ) : (
              <div
                style={{
                  flex: "0 0 200px",
                  minWidth: "200px",
                  maxWidth: "200px",
                  overflow: "hidden",
                }}
              ></div>
            )}
            <Sider
              theme="light"
              collapsible
              collapsed={isCollapsed}
              collapsedWidth={isHamburger ? 0 : 80}
              trigger={null}
              className="fixed top-0 left-0 h-full shadow z-20"
            >
              <Sidebar
                isHamburger={isHamburger}
                isCollapsed={isCollapsed}
                collapseToggle={collapseToggle}
                auth={auth}
              />
            </Sider>
            <Layout className="min-h-screen">
              <Header className="p-0 bg-white shadow z-10">
                <Topbar
                  isHamburger={isHamburger}
                  collapseToggle={collapseToggle}
                  auth={auth}
                />
              </Header>
              <Content className="bg-white">{childrenWithProps}</Content>
            </Layout>
          </Layout>
        </Spin>
      </div>
    </>
  )
}

export default AdminMain
